module.exports = __webpack_public_path__ + "static/img/12.582c13e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/eng/12.png
// module id = WyeL
// module chunks = 0